(() => {
    const itemSelector = '[data-filter-year-item]';
    const toggleSelector = '[data-filter-year-toggle]';
    const submenuSelector = '[data-filter-year-subitems]';
    const labelSelector = '[data-filter-year-label]';
    const activeItemSelector = '[data-filter-year-active="true"]';

    function setOpenState(item, open) {
        const toggle = item.querySelector(toggleSelector);
        const submenu = item.querySelector(submenuSelector);

        if (!(toggle instanceof HTMLElement) || !(submenu instanceof HTMLElement)) {
            return;
        }

        submenu.classList.toggle('hidden', !open);
        toggle.classList.toggle('after:rotate-180', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Schließen' : 'Öffnen');

        // Wenn ein jahr aufgeklappt ist, soll der Text des Labels dunkel werden. Das aktive Jahr ist schon hervorgehoben, dort nichts machen
        if (item.matches(activeItemSelector)) {
            return;
        }

        const label = item.querySelector(labelSelector);
        if (!(label instanceof HTMLElement)) {
            return;
        }

        label.classList.toggle('text-neutral-on-accent', open);
    }

    function syncInitialState(root = document) {
        root.querySelectorAll(itemSelector).forEach((item) => {
            if (!(item instanceof HTMLElement)) {
                return;
            }

            const submenu = item.querySelector(submenuSelector);
            if (!(submenu instanceof HTMLElement)) {
                return;
            }

            setOpenState(item, !submenu.classList.contains('hidden'));
        });
    }

    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        const toggle = target.closest(toggleSelector);
        if (!(toggle instanceof HTMLElement)) {
            return;
        }

        const item = toggle.closest(itemSelector);
        if (!(item instanceof HTMLElement)) {
            return;
        }

        event.preventDefault();

        const submenu = item.querySelector(submenuSelector);
        if (!(submenu instanceof HTMLElement)) {
            return;
        }

        const shouldOpen = submenu.classList.contains('hidden');
        setOpenState(item, shouldOpen);
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => syncInitialState(), { once: true });
    } else {
        syncInitialState();
    }

    document.addEventListener('htmx:afterSettle', () => syncInitialState());
})();
